import React from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";

interface UserLocationDotProps {
  position: google.maps.LatLngLiteral | null;
}

const UserLocationDot: React.FC<UserLocationDotProps> = ({ position }) => {
  if (!position) {
    return null;
  }

  return (
    <AdvancedMarker position={position}>
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: "#4285F4", // Google Blue
          borderRadius: "50%",
          border: "2px solid white",
          boxShadow: "0 0 0 2px rgba(66, 133, 244, 0.4)", // Pulse effect
        }}
      ></div>
    </AdvancedMarker>
  );
};

export default UserLocationDot;
